import https from "../../axios";
import { AxiosError } from "axios";
import { BaseResponse } from "../../db/response";
import normalizeBaseResponse from "../../utils/responseHandler";
import errorHandler from "../../utils/errorHandler";


interface VerifyOtpParams {
  otpCode: string;
  email: string;
}

export const selectTenant = async (params: {
  selectionToken: string;
  tenantId: number;
}): Promise<BaseResponse> => {
  const response = await https.post("/v1/auth/tenant/select", params);
  return normalizeBaseResponse(response.data);
};

export const doVerifyOtp = async (
  params: VerifyOtpParams
): Promise<BaseResponse> => {
  try {
    const response = await https.post("/v1/auth/verify-login-otp", params);
    return normalizeBaseResponse(response.data);

  } catch (error) {
    const axiosError = error as AxiosError<BaseResponse>;
    if (axiosError.response?.data) {
      return axiosError.response.data;
    }
    throw error;
  }
};

interface ResendOtpParams {
  emailOrPhone: string;
}

export const resendOtp = async (
  params: ResendOtpParams
): Promise<BaseResponse> => {
  try {
    // Ensure we're sending an object with emailOrPhone key
    const payload = { emailOrPhone: params.emailOrPhone };
    console.log("🔵 resendOtp: Sending payload", {
      payload,
      params,
      payloadType: typeof payload,
      payloadKeys: Object.keys(payload),
    });
    const response = await https.post("/v1/auth/resend-otp", payload);
    console.log("🟢 resendOtp: Response received", {
      status: response.status,
      data: response.data,
    });
    return normalizeBaseResponse(response.data);
  } catch (error) {
    console.error("🔴 resendOtp: Error occurred", error);
    return errorHandler(error);
  }
};
